// extracted by mini-css-extract-plugin
export default {"flexbox":"flexbox_flexbox__lUpIF"};